import { render, staticRenderFns } from "./ProfileSidebar.vue?vue&type=template&id=22d0762a&scoped=true"
import script from "./ProfileSidebar.vue?vue&type=script&lang=js"
export * from "./ProfileSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProfileSidebar.vue?vue&type=style&index=0&id=22d0762a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0762a",
  null
  
)

export default component.exports